import { generateItems } from 'domain/common';
import { Customer } from 'domain/lib';
import { asyncAction } from 'lib/actions';

const {
  actions: defaultActions,
  selectors,
  reducer,
} = generateItems('Customer', Customer);

const actions = {
  ...defaultActions,
  registerUserAction: asyncAction('CUSTOMER/REGISTER'),
};

export { actions, selectors, reducer };
